import "./styles.scss";

import moment from "moment";
import { useState } from "react";
import { FlagIcon } from "react-flag-kit";
import { useSelector } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
// import { IoAddOutline } from "react-icons/io5";
import { RiSubtractFill, RiAddFill } from "react-icons/ri";

import { timeDisplayFormat } from "../../../utils/utils";

function ModalMessageCoordinator({ showModalCoordinator, setShowModalCoordinator }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const [navBar, setNavBar] = useState(1);
  const [valueGeneralComment, setValueGeneralComment] = useState("");
  const [valueStudentComment, setValueStudentComment] = useState("");
  const [valueSpecificComment, setValueSpecificComment] = useState("");
  const [counterRepeatScheduling, setCounterRepeatScheduling] = useState(1);

  const handleCloseModal = () => setShowModalCoordinator(false);

  const handleCounterRepeatScheduling = (type) => {
    if (type === "sub" && counterRepeatScheduling > 1) setCounterRepeatScheduling((state) => state - 1);
    if (type === "add") setCounterRepeatScheduling((state) => state + 1);
  };

  const renderGeneralComment = () => (
    <div className="renderGeneralComment">
      <textarea value={valueGeneralComment} onChange={(e) => setValueGeneralComment(e.target.value)} />

      <div className="counter">
        <p>Repetições por agendamento:</p>
        <div onClick={() => handleCounterRepeatScheduling("sub")}>
          <RiSubtractFill color="#000" size={18} />
        </div>

        <span>{counterRepeatScheduling}</span>

        <div onClick={() => handleCounterRepeatScheduling("add")}>
          <RiAddFill color="#000" size={18} />
        </div>
      </div>
    </div>
  );

  const renderSpecificComment = () => (
    <div className="renderSpecificComment">
      <textarea value={valueSpecificComment} onChange={(e) => setValueSpecificComment(e.target.value)} />

      <div className="codeContent">
        <div className="buttonAdd">
          <span>Código da aula</span>

          {/* <IoAddOutline /> */}
        </div>
      </div>
    </div>
  );

  const renderStudentComment = () => (
    <div className="renderStudentComment">
      <textarea value={valueStudentComment} onChange={(e) => setValueStudentComment(e.target.value)} />
    </div>
  );

  return (
    <Dialog
      onClose={handleCloseModal}
      open={showModalCoordinator}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="containerModal">
        <div className="contentModal">
          <header>
            <h2 className="titleModal">Comentário da Coordenação</h2>

            <div></div>
            <div className="flag">
              <FlagIcon size={24} code={"US"} />
              <span>Ingles</span>
            </div>

            <p className="dateTime">
              {`${
                moment("2022-09-30").format(t("DATE_FORMAT")) +
                " • " +
                moment("2022-09-30T12:00:00").format(timeDisplayFormat(user?.timeDisplayFormat)) +
                " • " +
                moment("2022-09-30T12:00:00").add(30, "minute").format(timeDisplayFormat(user?.timeDisplayFormat))
              }`}
            </p>

            <p className="infoStudent">Estudante: João Victor Martins Teixeira</p>
          </header>

          <nav>
            <ul>
              <li onClick={() => setNavBar(0)} className={navBar === 0 && "active"}>
                Comentário Geral
              </li>
              <li onClick={() => setNavBar(1)} className={navBar === 1 && "active"}>
                Comentário Específico
              </li>
              <li onClick={() => setNavBar(2)} className={navBar === 2 && "active"}>
                Comentário do Aluno
              </li>
            </ul>
          </nav>

          {navBar === 0 && renderGeneralComment()}
          {navBar === 1 && renderSpecificComment()}
          {navBar === 2 && renderStudentComment()}
        </div>

        <div className="buttons">
          <button onClick={handleCloseModal}>{t("SAVE")}</button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalMessageCoordinator;
